import { getField } from 'vuex-map-fields';
import { isEmpty } from 'lodash';

const getters = {
  merchant: state => state.merchant,
  loadingMerchantList: state => state.loadingMerchantList,
  merchantLoaded: state => state.merchantLoaded,
  merchantList: state => state.merchantList,
  merchantName: state => state.merchantName,
  merchantLogo: state => state.merchantLogo,
  merchantId: state => (state.merchant.id || ''),
  settings: state => state.settings,
  availabilities: state => state.availabilities,
  membersAndInvitations: state => state.membersAndInvitations,
  membersMeta: state => state.membersMeta,
  members: state => state.members, // @todo: replace with organisation/currentOrganisationMembers
  analytics: state => state.analytics,
  taxList: state => state.taxList,
  merchantUpdated: state => state.merchantUpdated,
  planSubscriptionUpdated: state => state.planSubscriptionUpdated,
  availabilityUpdated: state => state.availabilityUpdated,
  availabilityTimesUpdated: state => state.availabilityTimesUpdated,
  invitationSent: state => state.invitationSent,
  invitationDeleted: state => state.invitationDeleted,
  memberRoleChanged: state => state.memberRoleChanged,
  memberTeamsChanged: state => state.memberTeamsChanged,
  memberDeleted: state => state.memberDeleted,
  merchantAvailability: state => state.merchantAvailability,
  merchantHasWhatsapp: state => !isEmpty(state.merchant.messaging_platforms.whatsapp),
  whatsappPhoneNumber: state => (!isEmpty(state.merchant.messaging_platforms.whatsapp) ? state.merchant.messaging_platforms.whatsapp.phone : ''),
  // stripeSuccessConnect: state => state.stripeSuccessConnect,
  // stripeSuccessDisconnect: state => state.stripeSuccessDisconnect,
  subscriptionsListReloaded: state => state.subscriptionsListReloaded,
  subscriptionsList: state => state.subscriptionsList,
  permissionRoles: state => state.permissionRoles,
  loadingMembers: state => state.loadingMembers,
  loadingData: state => state.loadingData,

  appKey: state => state.appKey,
  appKeyLoaded: state => state.appKeyLoaded,
  appKeyUpdated: state => state.appKeyUpdated,

  permissionRolesLoaded: state => state.permissionRolesLoaded,
  permissionRolesUpdated: state => state.permissionRolesUpdated,

  fetchingBlocked: state => state.fetchingBlocked,
  blocklist: state => state.blocklist,

  apiError: state => state.apiError,
  getField,
};

export default getters;
